var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"resume"},[_c('b-row',{staticClass:"overflow-auto"},[_c('b-col',{staticClass:"centering left-bar",attrs:{"cols":"4"}},[_c('contact'),_vm._v(" "),_c('skills')],1),_vm._v(" "),_c('b-col',{staticClass:"centering",attrs:{"cols":"8"}},[_c('about'),_vm._v(" "),_c('experience')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21ca0a76","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Resume.vue
// module id = null
// module chunks = 